import {AfterContentChecked, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatStepper} from '@angular/material/stepper';
import {PageService} from '../services/page.service';
import {ClienteComponent} from '../../components/cliente/cliente.component';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {ObservacionModalComponent} from '../modal/observacion-modal/observacion-modal.component';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-firma-documentos',
  templateUrl: './firma-documentos.component.html',
  styleUrls: ['./firma-documentos.component.css']
})
export class FirmaDocumentosComponent implements OnInit, AfterContentChecked {
  @ViewChild('clienteComprador', {static: false}) cliente: ClienteComponent;
  @ViewChild('stepper') stepper: MatStepper;
  datosVehiculos: FormGroup;
  DatoCliente: any;
  isEditable = true;
  vehiculoStepCompleted = false;
  solicitud: string;
  formData: FormData;
  clasif: any;
  spinnerEITV = false;
  spinnerGuardar = false;


  constructor(private cdRef: ChangeDetectorRef, private fb: FormBuilder, private servicio: PageService,
              private router: Router, public dialog: MatDialog) {

  }

  ngOnInit(): void {
    this.inicio();
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  get datosCliente(): any {
    return this.cliente ? this.cliente.cliente$ : null;
  }

  get bastidorNoValido(): any {
    return this.datosVehiculos.get('bastidor').invalid && this.datosVehiculos.get('bastidor').touched;
  }

  inicio(): void {
    this.solicitud = sessionStorage.getItem('id');
    sessionStorage.setItem('tipoCliente', '1');
    if (sessionStorage.getItem('colaborador') === 'null') {
      this.router.navigate(['page/home']);
    }
    this.clasificaciones();
    this.crearFormulario();
    if (this.solicitud !== 'null') {
      this.getSolicitud();
    }
  }

  crearFormulario(): any {
    this.datosVehiculos = this.fb.group({
      tipo: '',
      colaborador: '',
      usuarioweb: '',
      bastidor: ['', [Validators.required]],
      matricula: '',
      tipoVehiculo: '10',
      marca: '',
      modelo: '',
      observaciones: '',
    });
  }

  getSolicitud(): any {
    this.servicio.getOneSolicitud(this.solicitud).subscribe((res) => {
      this.setDatos(res);
    }, (error) => {
      console.log(error);
    });
  }

  getVehiculo(): void {
    if (this.datosVehiculos.value.matricula.length > 5) {
      this.servicio.getOneVehiculo(this.datosVehiculos.value.matricula).subscribe((res) => {
        if (res.matricula === this.datosVehiculos.value.matricula) {
          if (res.vehiculo != null) {
            this.setDato(res.vehiculo);
          } else {
            this.datosVehiculos.setValue({
              tipo: '',
              colaborador: '',
              usuarioweb: '',
              bastidor: '',
              matricula: this.datosVehiculos.value.matricula,
              tipoVehiculo: '10',
              marca: '',
              modelo: '',
              observaciones: '',
            });
          }
        }
      }, (error) => {
        console.log(error);
      });
    } else {
      this.datosVehiculos.setValue({
        tipo: '',
        colaborador: '',
        usuarioweb: '',
        bastidor: '',
        matricula: this.datosVehiculos.value.matricula,
        tipoVehiculo: '10',
        marca: '',
        modelo: '',
        observaciones: '',
      });
    }
  }

  setDatos(datos): any {
    this.datosVehiculos.controls.bastidor.setValue(datos.bastidor);
    this.datosVehiculos.controls.matricula.setValue(datos.matricula);
    if (datos.tipoVehiculo !== null) {
      const clasif = datos.tipoVehiculo.slice(0, 2);
      this.datosVehiculos.controls.tipoVehiculo.setValue(clasif);
    } else {
      this.datosVehiculos.controls.tipoVehiculo.setValue('10');
    }
    this.datosVehiculos.controls.marca.setValue(datos.marca);
    this.datosVehiculos.controls.modelo.setValue(datos.modelo);
  }

  siguiente(): void {
    const bastidor = this.datosVehiculos.get('bastidor').value?.trim();
    if (!bastidor) {
      this.datosVehiculos.get('bastidor').markAsTouched();
      Swal.fire('', 'El bastidor es obligatorio para continuar.', 'warning');
      this.vehiculoStepCompleted = false;
    } else {
      this.vehiculoStepCompleted = true;
      setTimeout(() => this.stepper.next());
    }
  }

  siguiente2($event: any): void {
    this.DatoCliente = {...$event, ...this.datosVehiculos.value};
    const c = this.clasif.find(res => res.id === this.datosVehiculos.value.tipoVehiculo);
    this.DatoCliente.tipoVehiculo = c ? c.descripcion : '';
    this.DatoCliente.tipo = 'FIRMA DOCUMENTOS';
    this.DatoCliente.tipoTramite = sessionStorage.getItem('tipoTramite');
    this.DatoCliente.numPedido = sessionStorage.getItem('numPedido');
    this.DatoCliente.colaborador = sessionStorage.getItem('colaborador');
    this.DatoCliente.usuarioweb = sessionStorage.getItem('email');
    const docs = [];
    if (sessionStorage.getItem('mandato') === 'true') { docs.push('Mandato'); }
    if (sessionStorage.getItem('poder') === 'true') { docs.push('Poder'); }
    this.DatoCliente.documentos = docs.join(', ');
  }

  guardar(): void {
    const dialogRef = this.dialog.open(ObservacionModalComponent, {
      width: '550px',
      data: this.DatoCliente,
      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog',
    });

    dialogRef.afterClosed().subscribe((result) => {
      const docu = {
        rol: 'VENDEDOR',
        docu: {
          poder: sessionStorage.getItem('poder') === 'true',
          mandato: sessionStorage.getItem('mandato') === 'true',
          compraVenta: false,
        },
      };
      this.DatoCliente.docu = JSON.stringify(docu);
      this.DatoCliente.observaciones = result.obs;
      this.DatoCliente.comunicarA = result.comunicarA;

      if (!this.DatoCliente.tipo) {
        this.DatoCliente.tipo = sessionStorage.getItem('tipo');
      }
      if (!this.DatoCliente.colaborador) {
        this.DatoCliente.colaborador = sessionStorage.getItem('colaborador');
      }
      if (!this.DatoCliente.usuarioweb) {
        this.DatoCliente.usuarioweb = sessionStorage.getItem('email');
      }

      this.formData = new FormData();
      Object.keys(this.DatoCliente).forEach((key) => {
        if (this.DatoCliente[key] !== null && this.DatoCliente[key] !== undefined) {
          this.formData.append(key, this.DatoCliente[key]);
        }
      });

      if (result.chekeado === true) {
        this.spinnerGuardar = true;
        this.servicio.add_file(this.formData).subscribe(
          (res) => {
            this.spinnerGuardar = false;
            Swal.fire('', 'Los datos se han guardado', 'success');
            this.router.navigate(['page/solicitudes']);
          },
          (error) => {
            this.spinnerGuardar = false;
            if (error.status === 202) {
              Swal.fire('', 'Se ha guardado la solicitud pero ha habido un error de comunicación con el servidor.', 'warning');
              this.router.navigate(['page/solicitudes']);
            } else {
              Swal.fire('', 'Ha ocurrido un error al guardar los datos.', 'error');
            }
          }
        );
      }
    });
  }

  clasificaciones(): void {
    this.clasif = [{id: '03', descripcion: '03xx – CICLOMOTOR'}, {id: '04', descripcion: '04xx – MOTOCICLETA'},
      {id: '06', descripcion: '06xx – AUTOMOVIL DE TRES RUEDAS'}, {id: '10', descripcion: '10xx – TURISMO'},
      {id: '17', descripcion: '17xx – PICK UP'}, {id: '20', descripcion: '20xx – CAMION MMA <=3.500 kg'},
      {id: '21', descripcion: '21xx – CAMION 3.500 kg. < MMA <= 12.500 kg'}, {id: '22', descripcion: '22xx – CAMION MMA > 12.000 kg'},
      {id: '24', descripcion: '24xx – FURGON/FURGONETA MMA <= 3.500 kg'}, {id: '31', descripcion: '31xx – VEHICULO MIXTO ADAPTABLE'},
      {id: '32', descripcion: '32xx – AUTO-CARAVANA MMA <= 3.500 kg'}, {id: '33', descripcion: '33xx – AUTO-CARAVANA MMA > 3.500 kg'},
      {id: '66', descripcion: '66xx – QUAD ATV'}
    ];
  }

  setDato(datos): void {
    this.datosVehiculos.controls.bastidor.setValue(datos.bastidor);
    this.datosVehiculos.controls.matricula.setValue(datos.matricula);
    if (datos.clasificacion !== null) {
      const clasif = datos.clasificacion.slice(0, 2);
      this.datosVehiculos.controls.tipoVehiculo.setValue(clasif);
    } else {
      this.datosVehiculos.controls.tipoVehiculo.setValue('10');
    }
    this.datosVehiculos.controls.marca.setValue(datos.marca);
    this.datosVehiculos.controls.modelo.setValue(datos.modelo);
  }

  getDatosEITV(): void {
    if (!this.datosVehiculos.get('bastidor').value?.trim()) {
      Swal.fire('', 'Se necesita un bastidor válido para recuperar los datos del vehículo desde la DGT', 'warning');
    } else {
      this.spinnerEITV = true;
      this.servicio.getEITV(this.datosVehiculos.get('bastidor').value).subscribe({
        next: value => {
          if (value.error === 'ERROR') {
            Swal.fire('', 'Error recuperando los datos: ' + value.content + '. Por favor rellene manualmente los datos.', 'warning');
          } else {
            Swal.fire('', 'Datos EITV recuperados con éxito', 'success');
            this.datosVehiculos.controls.marca.setValue(value.content.datos.MARCA);
            this.datosVehiculos.controls.modelo.setValue(value.content.datos.MODELO);
            this.datosVehiculos.controls.tipoVehiculo.setValue(value.content.datos.CLASIFICACION_VEHICULO.slice(0, 2));
          }
        },
        error: err => {
          console.log(err);
          Swal.fire('', 'Imposible conectar con la DGT, por favor compruebe el bastidor y si es correcto rellene manualmente los datos del vehículo', 'warning');
        },
        complete: () => {
          this.spinnerEITV = false;
        }
      });
    }
  }
}
